import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../store/reducers';
import TextInput from './TextInput';
import AresInput from './AresInput';
import Select from './Select';
import countries  from '../enums/countries';
import { setStep } from '../store/actions';
import { guestFields, companyFields } from '../enums/Guest';
import CheckboxInput from './CheckboxInput';
import withLocalize from '../withLocalize';
import T from './Translate';

class Step3 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(3));
	}

	render() {

		const { formValues, translate: t } = this.props;

		return (
			<section className="container">
				<fieldset className="fieldset">
					<legend><T id="Step3.guestFields.title" /></legend>
					{[0].map((row, index) => (
						<div className="fieldset__fields-row" key={index}>
							{[row, row+1].map((field, index) => (
								<Field
									component={TextInput}
									name={guestFields[field].name}
									label={t(guestFields[field].label)}
									key={guestFields[field].name}
									textarea={guestFields[field].textarea || false}
									required={guestFields[field].required !== undefined ? guestFields[field].required : true}
								/>
							))}
						</div>
					))}

					<div className="fieldset__fields-row">
						{[2].map((field, index) => (
							<Field
								component={TextInput}
								name={guestFields[field].name}
								label={t(guestFields[field].label)}
								key={guestFields[field].name}
								textarea={guestFields[field].textarea || false}
								required={guestFields[field].required !== undefined ? guestFields[field].required : true}
							/>
						))}

						{[3].map((field, index) => (
							<Field
								component={TextInput}
								name={guestFields[field].name}
								label={t(guestFields[field].label)}
								key={guestFields[field].name}
								textarea={guestFields[field].textarea || false}
								required={guestFields[field].required !== undefined ? guestFields[field].required : true}
								placeholder="+420"
							/>
						))}
					</div>

					{[4,6].map((row, index) => (
						<div className="fieldset__fields-row" key={index}>
							{[row, row+1].map((field, index) => (
								<Field
									component={TextInput}
									name={guestFields[field].name}
									label={t(guestFields[field].label)}
									key={guestFields[field].name}
									textarea={guestFields[field].textarea || false}
									required={guestFields[field].required !== undefined ? guestFields[field].required : true}
								/>
							))}
						</div>
					))}
				</fieldset>

				<fieldset className="fieldset">
					<legend><T id="Step3.companyFields.title" /></legend>

					<Field
						component={CheckboxInput}
						name="isCompany"
						id="guest-isCompany"
						label={t('Step3.companyFields.isCompany')}
					/>

					<div className={!formValues.isCompany ? 'hidden' : ''}>
						<div className="fieldset__fields-row">
							<Field
								component={AresInput}
								name="companyIc"
								label={t('enums.Guest.companyFields.ic')}
								required={false}
							/>
						</div>

						<div className="fieldset__fields-row">
							{[0, 2].map((field, index) => (
								<Field
									component={TextInput}
									name={companyFields[field].name}
									label={t(companyFields[field].label)}
									key={companyFields[field].name}
									required={companyFields[field].required !== undefined ? companyFields[field].required : true}
								/>
							))}
						</div>

						<div className="fieldset__fields-row">
							{[3, 4].map((field, index) => (
								<Field
									component={TextInput}
									name={companyFields[field].name}
									label={t(companyFields[field].label)}
									key={companyFields[field].name}
									required={companyFields[field].required !== undefined ? companyFields[field].required : true}
								/>
							))}
						</div>

						<div className="fieldset__fields-row">
							<Field
								component={TextInput}
								name="companyPostCode"
								label={t('enums.Guest.companyFields.postCode')}
								required={true}
							/>
							<Field
								component={Select}
								name="companyCountry"
								label={t('enums.Guest.companyFields.country')}
								options={countries}
							/>
						</div>
					</div>

				</fieldset>

			</section>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		terms: state.app.terms,
	})),
	withLocalize,
)(Step3);



// WEBPACK FOOTER //
// ./src/components/Step3.jsx